import { Layout } from 'antd';
import styled from 'styled-components';

export default styled(Layout.Content)`
  background: #ffffff;
  padding: 24px;
  height: 100%;
  margin-top: 40px;

  @media (max-width: 576px) {
    margin-top: 0px;
  }
`;
